import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from 'shared/hooks/useWindowDimensions';
import { ToggleTranslateButton } from 'shared/ui/toggle-translate-button';
import { LoginPassword } from '../components/login-password';
import { LoginOtp } from '../components/login-otp';
import ImageBackground from 'shared/assets/images/bg-image-login.png';
import ImageLogo from 'shared/assets/images/logo_sembuh_ai.png';

const LoginPage = () => {
  const { t } = useTranslation('common');
  const { isMobile } = useWindowDimensions();
  const [loginOtp, setLoginOtp] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  return (
    <main
      className="w-full content-center h-screen flex flex-col items-center md:bg-slate-100"
      style={{
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: isMobile ? 'cover' : '100% 100%',
        backgroundPosition: isMobile ? 'center' : 'top',
      }}
    >
      <div className="flex items-center justify-center h-full w-full mt-[-24px] px-4 md:px-0">
        <div
          className={`w-full ${!loginOtp ? 'md:w-1/4' : 'md:w-[500px]'} flex flex-wrap p-8 rounded-2xl bg-white justify-center items-center text-center`}
        >
          <div className="w-full contents">
            <img src={ImageLogo} alt="Sembuh AI logo" className="sl-w-auto" />
          </div>
          {!loginOtp ? (
            <LoginPassword
              formData={formData}
              setFormData={setFormData}
              setLoginOtp={setLoginOtp}
            />
          ) : (
            <LoginOtp
              setLoginOtp={setLoginOtp}
              loginOtp={loginOtp}
              formData={formData}
            />
          )}
          <div
            className={`w-full flex justify-between items-center gap-1 mt-10 ${loginOtp ? 'px-3' : ''}`}
          >
            <p>{t('select_language')}</p>
            <ToggleTranslateButton />
          </div>
        </div>
      </div>
    </main>
  );
};

export default LoginPage;
